import { Tooltip as AntTooltip } from "antd";
import * as styles from "./tooltip.module.scss";

export const Tooltip = ({
  title,
  placement,
  children,
  showArrow = true,
  useLineBreaks = true,
  ...props
}) => {
  return (
    <AntTooltip
      title={title}
      placement={placement}
      overlayClassName={styles.tooltip}
      showArrow={showArrow}
      overlayInnerStyle={ useLineBreaks ? undefined : { width: 'max-content' } }
      {...props}
    >
      {children}
    </AntTooltip>
  );
};
